import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { TaskCategoryListing, TaskCategoryAddEdit } from './Pages';

export const TaskCategoryRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={TaskCategoryListing} />
        <Route exact path={`${match.path}/AddEdit`} component={TaskCategoryAddEdit} />
    </Fragment>
)